import { render, staticRenderFns } from "./TermsAndConditionsForUpgrade.vue?vue&type=template&id=64ce1f8a&scoped=true&"
import script from "./TermsAndConditionsForUpgrade.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsForUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsForUpgrade.vue?vue&type=style&index=0&id=64ce1f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce1f8a",
  null
  
)

export default component.exports